import { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

import api, { handleApi } from "pages/api/api";
import { useAlert } from "pages/context/AlertContext";
import { useAuth } from "pages/context/AuthContext";

/**
 * Mostra um dialog MODAL obrigatório sempre que userData.pwdprovisoria === 1.
 * Impede fechar com ESC e clique no backdrop.
 */
export default function ForcePasswordChange() {
  const { userData, login } = useAuth();
  const { showAlert } = useAlert();

  const [open, setOpen] = useState(false);
  const [newPwd, setNewPwd] = useState("");
  const [newPwd2, setNewPwd2] = useState("");
  const [saving, setSaving] = useState(false);

  // ativa se a sessão indicar pwd provisória
  useEffect(() => {
    setOpen(!!userData && userData.pwdprovisoria === 1);
  }, [userData]);

  if (!open) return null;

  async function handleSave() {
    if (!newPwd || newPwd.length < 6) return showAlert("Mínimo 6 caracteres.", "warning");
    if (newPwd !== newPwd2) return showAlert("As passwords não coincidem.", "warning");

    setSaving(true);
    const [_, err, meta] = await handleApi(
      api.post("Auth/ChangePassword", { id: userData?.id, newPwd })
    );
    setSaving(false);

    if (err) return showAlert(err, "error");

    // marca localmente como não provisória mantendo o token
    const token = localStorage.getItem("token");
    const updated = { ...userData, pwdprovisoria: 0 };
    login(updated, token);

    showAlert(meta?.message || "Password alterada com sucesso.", "success");
    setOpen(false);
  }

  return (
    <Dialog
      open={open}
      // NÃO permite fechar (é obrigatório)
      onClose={() => {}}
      maxWidth="xs"
      fullWidth
      disableEscapeKeyDown
      slotProps={{ backdrop: { onClick: () => {} } }}
    >
      <DialogTitle>Alterar password</DialogTitle>
      <DialogContent>
        <MDTypography variant="button" color="text" sx={{ display: "block", mb: 1 }}>
          A sua password é provisória. Defina uma nova password para continuar.
        </MDTypography>

        <MDBox mt={1} mb={1.5}>
          <MDInput
            type="password"
            label="Nova password"
            fullWidth
            value={newPwd}
            onChange={(e) => setNewPwd(e.target.value)}
          />
        </MDBox>

        <MDBox mb={1}>
          <MDInput
            type="password"
            label="Confirmar nova password"
            fullWidth
            value={newPwd2}
            onChange={(e) => setNewPwd2(e.target.value)}
          />
        </MDBox>
      </DialogContent>
      <DialogActions>
        <MDButton color="info" onClick={handleSave} disabled={saving}>
          {saving ? "A guardar..." : "Guardar e continuar"}
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
